import { GlossDateType } from "../../../../../models/types/gloss-date-types";

export const anchorPoint: GlossDateType = {
  date: "2023-01-01",
  time: null,
  tz: null,
};
